import instance from "./index";

const normalizeJobTitle = (jobTitle) => ({
  ...jobTitle,
  jobTitleId:
    jobTitle?.jobTitleId ??
    jobTitle?.JobTitleId ??
    jobTitle?.id ??
    jobTitle?.Id ??
    null,
  jobTitleName:
    jobTitle?.jobTitleName ??
    jobTitle?.JobTitleName ??
    jobTitle?.name ??
    "",
});

export const getAllJobTitles = async () => {
  try {
    const response = await instance.get("/jobTitle/getAll");
    const data = response?.data;
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : [];

    return list.map(normalizeJobTitle);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load job titles";
    throw new Error(message);
  }
};

export const getJobTitleById = async (jobTitleId) => {
  if (jobTitleId === undefined || jobTitleId === null || jobTitleId === "") {
    throw new Error("Job title id is required");
  }

  try {
    const response = await instance.get(`/jobTitle/getById/${jobTitleId}`);
    const data = response?.data?.data ?? response?.data;
    return normalizeJobTitle(data);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load job title";
    throw new Error(message);
  }
};

export const updateJobTitle = async ({ jobTitleId, jobTitleName }) => {
  const trimmedName = String(jobTitleName ?? "").trim();

  if (jobTitleId === undefined || jobTitleId === null || jobTitleId === "") {
    throw new Error("Job title id is required");
  }

  if (!trimmedName) {
    throw new Error("Job title name is required");
  }

  try {
    const response = await instance.put(
      `/jobTitle/updateJobTitle/${jobTitleId}`,
      {
        jobTitleName: trimmedName,
      },
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to update job title";
    throw new Error(message);
  }
};

export const createJobTitle = async ({ jobTitleName }) => {
  const trimmedName = String(jobTitleName ?? "").trim();

  if (!trimmedName) {
    throw new Error("Job title name is required");
  }

  try {
    const response = await instance.post("/jobTitle", {
      jobTitleName: trimmedName,
    });
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create job title";
    throw new Error(message);
  }
};
